module.exports = __webpack_public_path__ + "static/media/logo.74e7adc5.png";